import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import companiesReducer from './companiesSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    companies: companiesReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
